module.exports = __webpack_public_path__ + "img/07.d7e4e760.jpg";